export interface ITriggerConfig {
  id: string;
  title: (signatureName?: string) => string;
  description: (signatureName?: string) => string;
  actions: { [key: string]: any };
}

export const TriggerIds = {
  SAVE_TO_ENTITY: 'post-SaveToEntity',
  SEND_FOR_SIGNATURE: 'post-SendForSignature',
  RECEIVED_FROM_SIGNATURE: 'post-ReceivedFromSignature',
} as const;

export const DOCUSIGN_TRIGGER_IDS = [
  TriggerIds.SEND_FOR_SIGNATURE,
  TriggerIds.RECEIVED_FROM_SIGNATURE,
] as const;
